var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolojasno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_2",
    "data-name": "Vrstva 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 215.71 153.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_1-2",
    "data-name": "Vrstva 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.47,152.84l-124.39.29c-10.28.02-19.32-7.8-22.35-16.5-3.42-9.81.37-18.42,7.36-24.59l1.63-13.04c-10.76-5.8-18.25-16.21-19.78-28.96-1.57-13.1,3.73-25.98,12.67-34.56,9.98-9.58,23.41-13.18,37.08-11.08,15.95,2.44,28.42,12.8,32.97,28.61,25.51-11.72,55.56-.14,65.22,26.09,13.57-.95,26.72,3.67,35.05,14.48s10.3,24.82,4.57,37.65c-4.55,10.17-15.92,21.59-30.02,21.62ZM83.52,78.02c4.49-9.64,10.32-16.66,18.93-22.24-2.15-6.84-5.58-13.61-11.67-18.18-15.39-11.54-37.56-10.17-50.66,4.02-9.4,10.19-11.61,24.62-6.49,37.16,2.66,6.52,7.73,11.36,13.76,14.49,7.82-12.8,21.65-19.07,36.13-15.25ZM41.95,135.63c2.55,6.18,9.67,11.47,17.05,11.47l120.67-.05c13.34,0,24.66-10.1,28.41-21.84,3.62-11.34-.05-23.14-7.74-30.78-8.04-7.99-19.7-10.84-31.48-7.97-6.28-24.07-29.81-37.32-53.28-29.83-13.49,4.3-23.53,14.49-27.41,28.32-2.27.42-4.37-.51-6.69-1.11-15.82-4.14-32.66,8.93-31.83,25.47.1,2,1.62,6,.05,6.8-7.6,3.87-11.34,10.85-7.76,19.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.84,102.33c-.83.61-3.89-.23-4.39-1-.6-.92.04-3.27,1.01-3.96l10.35-7.29c.76-.54,2.99-.54,3.77-.06.94.58,1.1,3.68.04,4.45l-10.78,7.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.44,19.66c.64.97.38,3.88-.47,4.52s-3.6.21-4.2-.72l-6.7-10.39c-.52-.81.09-3.58.89-4.1.96-.61,3.44.1,4.08,1.07l6.39,9.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.63,14.1c.01,1.16-1.59,3.12-2.49,3.29-1.08.21-3.3-1.71-3.31-2.84l-.08-11.17c0-1.14,1.55-3.15,2.58-3.36s3.14,1.6,3.16,2.75l.14,11.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.53,36.03c-.86.69-3.31.71-4.13.32-1.03-.49-1.06-3.66-.05-4.45l10.12-7.83c.7-.54,3.8.42,4.11,1.17.4.94-.19,2.9-1.12,3.64l-8.93,7.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7,19.96c-.42.8-2.54,1.76-3.33,1.84-.98.11-2.53-2.27-2.12-3.19l4.79-10.62c.46-1.03,3.2-2.16,4.27-1.91s2.07,3.08,1.52,4.14l-5.14,9.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.67,69.2l-12.78-.03c-1.03,0-2.77-1.41-2.89-2.3s1.91-2.87,2.85-2.86l11.79.07c.85,0,2.61,1.35,3.07,1.93.57.73-1.05,3.19-2.04,3.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.33,43.44l-10.44-5.76c-.79-.43-1.65-2.96-1.45-3.81.24-1.06,3.01-1.8,4-1.24l10.2,5.79c.71.4,1.25,2.54,1.36,3.32s-2.83,2.16-3.67,1.7Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolojasno);
export default __webpack_public_path__ + "static/media/polojasno.a94a18e208ce48e952789748fa1a4da5.svg";
export { ForwardRef as ReactComponent };